import { render, staticRenderFns } from "./SideBarDonika.vue?vue&type=template&id=2d82bfc6&scoped=true"
import script from "./SideBarDonika.vue?vue&type=script&lang=js"
export * from "./SideBarDonika.vue?vue&type=script&lang=js"
import style0 from "./SideBarDonika.vue?vue&type=style&index=0&id=2d82bfc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82bfc6",
  null
  
)

export default component.exports